import React from 'react';
import { useHistory } from 'react-router-dom';
import { AuthContent, AuthContentInner, AuthContentLayout, AuthHeader, AuthInviteButtonWrap, AuthInviteContainer, Button } from 'components';
import Illustration from 'images/illustrations/not-found.svg';
import { routeConstants } from 'routes';

const AuthLogin: React.FC = () => {
  const history = useHistory();

  return (
    <AuthInviteContainer>
      <AuthContent data-cy="invitation-already-claimed-container">
        <AuthContentInner>
          <AuthHeader data-cy="invitation-invalid-header" title="Invitation Is Invalid" subtitle="Contact your manager to get a new one. In the meantime, you can log in to an existing account." />
          <img alt="Not Found Illustration" aria-hidden="true" src={Illustration} />
          <AuthContentLayout>
            <AuthInviteButtonWrap>
              <Button data-cy="landing-btn" label="Log in" type="submit" appearance="primary" size="large" onClick={() => history.push(routeConstants.public.rootPath)} />
            </AuthInviteButtonWrap>
          </AuthContentLayout>
        </AuthContentInner>
      </AuthContent>
    </AuthInviteContainer>
  );
};

export default AuthLogin;
